import { FormControl, MenuItem, Select, styled } from '@mui/material';
import { useConfig } from '../../Hooks/useConfig';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { LanguageList } from '../../utils/data';
import { setCookie } from '../../utils/cookies';

const UnstyledSelect = styled(Select)(({}) => ({
  border: 'none',
  outline: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    outline: 'none',
    border: 'none',
  },
}));

const ChangeLanguage = () => {
  const { lng, baseDomain } = useConfig();
  const [lang, setLang] = useState(lng ? lng : 'en');
  const selectedLanguage = (event) => {
    setLang(event.target.value);
    i18n.changeLanguage(event.target.value);
    setCookie('lng', event.target.value, 3600, baseDomain);
  };

  const { i18n } = useTranslation();
  return (
    <FormControl sx={{ mt: 5, minWidth: 120 }} size="small">
      <UnstyledSelect
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={lang}
        label="Age"
        onChange={selectedLanguage}
      >
        {LanguageList.map((item) => {
          return (
            <MenuItem key={item.value} value={item.value}>
              {item.text}
            </MenuItem>
          );
        })}
      </UnstyledSelect>
    </FormControl>
  );
};
export default ChangeLanguage;
